module.exports = __webpack_public_path__ + "static/media/carp_mobile2_firebase_notification.cae4d38b.gif";